import React from 'react';
import { useSelector } from 'react-redux';

import { selectUser } from 'app/store/userSlice';

export type IsModuleDisabledType = (module: string) => boolean;

export default function useIsModuleDisabled() {
	const { app } = useSelector(selectUser);

	const isModuleDisabled: IsModuleDisabledType = React.useCallback(
		(module: string) => {
			const settings = app.modules?.find(_module => _module.modu_title === module.replaceAll('-', '_'));
			if (!settings) return true;
			return settings?.modu_disabled;
		},
		[app?.modules]
	);

	return isModuleDisabled;
}
